import { sendApiCall } from "../../utilities/api.js";
import { LastViewedArticleDto } from "../../models/LastViewedArticleDto.js";

export const sendLastViewedProduct = (productID?: number | null, articleID?: number | null, productName?: String | null) =>
{
    // Only send last viewed when article is NOT soldout
    if ($('.out-of-order').length == 0)
    {
        let prodName = productName;
        if (prodName !== null && typeof ($('.js-article-data').data('name')) != typeof (undefined))
            prodName = $('.js-article-data').data('name');

        // Defer work that isn't user-visible to a separate task
        setTimeout(() =>
        {
            if (shopConfig().api.active)
            {
                productID = productID ?? parseInt($("#shopid").val() as string);
                articleID = articleID ?? parseInt($("#shopart").val() as string);
                const body = new LastViewedArticleDto({
                    productID: productID,
                    articleID: articleID,
                    productName: prodName.replace("\\", "")
                });

                sendApiCall({ endpoint: "/Filter/add-last-viewed", rawUrl: location.pathname, customDto: body });
            }
            else
            {
                $.ajax({
                    type: "POST",
                    url: "/Services/Modules/Webshop.asmx/AddArticleToLastViewed",
                    contentType: "application/json; charset=utf-8",
                    data: "{\"articleID\":" + $("#shopart").val() + ",\"productID\":" + $("#shopid").val() + ",\"prodName\":\"" + prodName + "\"}",
                    dataType: "json"
                });
            }
        }, 0);
    }
}

(window as any).sendLastViewedProduct = sendLastViewedProduct;
